import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/AIML/ShowQuantAnalysisDetails";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const ShowQuantAnalysisDetailsTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="ShowQuantAnalysisDetails">
      <TabletNotice page="ShowQuantAnalysisDetails" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default ShowQuantAnalysisDetailsTablet;